module.exports = __webpack_public_path__ + "img/OrgChartTemp7.6bf679fc.png";